// this file is generated by update_shopify_store_data.py at 2026-06-22 20:33:58.411141
var courses = [];